import { Component, type OnDestroy, type OnInit } from '@angular/core'
import { type User } from '@inside-hub-app/customer-portal-b2c-client'
import { CptGoogleTagmanagerService, type GTMEventData, CustomerPortalSharedModule } from '@inside-hub-app/customer-portal-shared'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { KeycloakService } from 'keycloak-angular'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { NGXLogger } from 'ngx-logger'
import { type ParsedToken } from '../../../../models/keycloak'
import { type UpcomingAppointmentDTO } from '../../../services/appointments.service'
import { DataService } from '../../../services/data.service'
import { SharedService } from '../../../services/shared.service'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { NgxGlideModule } from 'ngx-glide'
import { GoogleMapsModule } from '@angular/google-maps'
import { A11yModule } from '@angular/cdk/a11y'
import { TextFieldModule } from '@angular/cdk/text-field'
import { FooterContainerComponent } from '../../../components/basic/footer-container/footer-container.component'
import { RevolutionUpcomingAppointmentsComponent } from '../../../components/revolution/appointments/revolution-upcoming-appointments/revolution-upcoming-appointments.component'
import { NavbarComponent } from '../../../components/revolution/navigation/navbar/navbar.component'
import { NavbarSecondComponent } from '../../../components/revolution/navigation/navbar-second/navbar-second.component'
@Component({
  selector: 'customer-portal-app-revolution-appointments-view',
  standalone: true,
  templateUrl: './revolution-appointments-view.component.html',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomerPortalSharedModule,
    HubChildTranslateModule,
    NgxSkeletonLoaderModule,
    NgxGlideModule,
    GoogleMapsModule,
    A11yModule,
    TextFieldModule,
    FooterContainerComponent,
    RevolutionUpcomingAppointmentsComponent,
    NavbarComponent,
    NavbarSecondComponent
  ]
})
export class RevolutionAppointmentsViewComponent implements OnInit, OnDestroy {
  upcomingAppointments: UpcomingAppointmentDTO[] = []

  sub = {
    onUpcomingAppointmentsLoaded: null,
    upcomingAppointmentsLoading: null
  }

  constructor (
    private readonly keycloak: KeycloakService,
    private readonly dataService: DataService,
    private readonly logger: NGXLogger,
    private readonly cptGtmService: CptGoogleTagmanagerService,
    private readonly sharedService: SharedService,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>
  ) {
    this.hasNewFooter = this.remoteConfigService.get('hasNewFooter')
  }

  token: ParsedToken
  user: User
  loading = true
  error = null
  public hasNewFooter

  ngOnInit (): void {
    this.sub.onUpcomingAppointmentsLoaded =
      this.dataService.onUpcomingAppointmentsLoaded.subscribe(
        upcomingAppointments => {
          this.upcomingAppointments = upcomingAppointments

          const gtmData: GTMEventData = {
            event: 'gaEvent2',
            event_name: 'my_appointments_listing',
            my_appointments_listing: {
              appointments: this.upcomingAppointments.length.toString(),
              event_action: 'Listing',
              event_category: 'My Appointments',
              event_label: this.upcomingAppointments.length.toString()
            }
          }
          this.cptGtmService.send(gtmData)
        },
        error => {
          this.logger.debug(error)
        }
      )

    this.sub.upcomingAppointmentsLoading =
      this.dataService.loading.upcomingAppointments.subscribe(loading => {
        this.loading = loading
      })

    this.token = this.keycloak.getKeycloakInstance().tokenParsed as ParsedToken
  }

  ngOnDestroy (): void {
    this.sharedService.unsubscribe(this.sub)
  }
}
